import React from 'react';
import { bool, string, func } from 'prop-types';

import { useField } from 'react-final-form';

import Layout from './Layout';

const fieldClasses = {
  input: true,
  textarea: true,
};

const getFieldClass = ({ component }) => (fieldClasses[component] ? component : 'input');

export default function PasswordField(props) {
  const { input, meta } = useField(props.name, {
    validate: props.validate,
  });

  const {
    isHorizontal, label, noLayout, addonLabel, errors,
  } = props;

  if (noLayout) {
    return <input {...input} placeholder={props.placeholder} />;
  }
  const error = meta.touched && (meta.error || meta.submitError);

  return (
    <Layout
      label={label}
      isHorizontal={isHorizontal}
      type="text"
      addonLabel={addonLabel}
    >
      {addonLabel && (
        <div className="control">
          <div className="button is-static">{addonLabel}</div>
        </div>
      )}
      <div>
        <input
          type="password"
          placeholder={props.placeholder}
          className={`${getFieldClass(props)} ${errors && 'is-danger'} ${error && 'is-danger'}`}
          {...input}
        />
        {props.children}
      </div>

      {error && <p className="help is-danger">{error}</p>}

      {errors && errors.map((error) => <p className="help is-danger">{error}</p>)}

    </Layout>
  );
}

PasswordField.propTypes = {
  isHorizontal: bool,
  label: string,
  noLayout: bool,
  name: string.isRequired,
  validate: func,
  placeholder: string,
  addonLabel: string,
};
